import { useState } from 'react';
import { Radar } from 'lucide-react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../components/ui/tabs';
import { useAuth } from '../contexts/AuthContext';
import NeedsTab from '../components/sourcing/NeedsTab';
import MyDraftsTab from '../components/sourcing/MyDraftsTab';
import RfqLogTab from '../components/sourcing/RfqLogTab';
import SkuSearchTab from '../components/sourcing/SkuSearchTab';
import VariantsTab from '../components/sourcing/VariantsTab';
import HotListTab from '../components/sourcing/HotListTab';
import AdminTab from '../components/sourcing/AdminTab';

export default function SourcingPage() {
  const { canAccess } = useAuth();
  const canEdit = canAccess('SOURCING', 'EDIT');
  const [tab, setTab] = useState('needs');

  return (
    <div className="p-6 space-y-6" data-testid="sourcing-page">
      <div className="flex items-center gap-2">
        <Radar className="h-6 w-6 text-primary" />
        <h1 className="text-2xl font-semibold">Sourcing</h1>
      </div>

      <Tabs value={tab} onValueChange={setTab}>
        <div className="overflow-x-auto -mx-6 px-6 sm:mx-0 sm:px-0" data-testid="sourcing-tabs-scroll">
          <TabsList className="w-max">
            <TabsTrigger value="needs" data-testid="sourcing-tab-needs">Needs</TabsTrigger>
            <TabsTrigger value="drafts" data-testid="sourcing-tab-drafts">My Drafts</TabsTrigger>
            <TabsTrigger value="rfqs" data-testid="sourcing-tab-rfqs">RFQ Log</TabsTrigger>
            <TabsTrigger value="sku-search" data-testid="sourcing-tab-sku-search">SKU Search</TabsTrigger>
            <TabsTrigger value="hot-list" data-testid="sourcing-tab-hot-list">Hot List</TabsTrigger>
            {canEdit && <TabsTrigger value="variants" data-testid="sourcing-tab-variants">Variants</TabsTrigger>}
            {canEdit && <TabsTrigger value="admin" data-testid="sourcing-tab-admin">Admin</TabsTrigger>}
          </TabsList>
        </div>

        <TabsContent value="needs"><NeedsTab /></TabsContent>
        <TabsContent value="drafts"><MyDraftsTab /></TabsContent>
        <TabsContent value="rfqs"><RfqLogTab /></TabsContent>
        <TabsContent value="sku-search"><SkuSearchTab /></TabsContent>
        <TabsContent value="hot-list"><HotListTab /></TabsContent>
        {canEdit && <TabsContent value="variants"><VariantsTab /></TabsContent>}
        {canEdit && <TabsContent value="admin"><AdminTab /></TabsContent>}
      </Tabs>
    </div>
  );
}
